import React, { useState, useEffect } from "react";
import "../CSS/search.css";
import Navbar from "../COMPONENT/Navbar/Navbar";
import "../COMPONENT/ProductCard/productCard.css";
import Footer from "../COMPONENT/Footer/Footer";
import NoData from "../COMPONENT/NoData";
import Loader from "../COMPONENT/Loader";
import Notfound from "./NotFound";
import img from "../Images/default.png";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCart } from "../store/cartSlice";
import { useParams } from "react-router-dom";
import { setProducts, setURL } from "../store/storeDataSlice";
import axios from "axios";

const Search = () => {
  const { name } = useParams();
  const { data, url } = useSelector((state) => state.product);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isLinkExist, setIsLinkExist] = useState(false);

  const handleSelectedProduct = (product) => {
    navigate(`/${url}/product/${product.productName}/${product._id}`);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    const filteredData = data.products.filter((item) =>
      item.productName.toLowerCase().includes(term.toLowerCase())
    );
    setSearchResults(filteredData);
  };

  const handleAdd = (item) => {
    let cart = JSON.parse(localStorage.getItem(url));

    if (!cart) {
      cart = [];
    }

    const existingItem = cart.find((cartItem) => cartItem._id === item._id);

    if (existingItem) {
      alert("This item is already in your cart.");
    } else {
      cart.push(item);
      localStorage.setItem(url, JSON.stringify(cart));
      alert("Item added to your cart.");
      dispatch(setCart(JSON.parse(localStorage.getItem(url))));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_API}/get-store`,
          { businessLink: name }
        );
        setLoading(false);
        if (response.data.message === "Invalid URL") {
          setIsLinkExist(false);
        } else if (response.data.message === "Valid URL") {
          setIsLinkExist(true);
          dispatch(setProducts(response.data.data));
          dispatch(setURL(name));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [name, dispatch]);
 
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isLinkExist ? (
            <>
              <Navbar />
              <div className="container">
                <div className="header2">
                  <input
                    className="search-input"
                    type="text"
                    placeholder={`Search products...`}
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                  />
                </div>
                {/* ----------------------Producr card start ----------------- */}
                <>
                  {data.products ? (
                    <div className="category-container1">
                      {(searchResults.length > 0
                        ? searchResults
                        : data.products
                      ).map((product, index) => (
                        <div className="product-card1" key={index}>
                          <div onClick={() => handleSelectedProduct(product)}>
                            <img
                              className="product-image1"
                              src={
                                product.images.length > 0
                                  ? `${process.env.REACT_APP_PRODUCT_IMAGE_PATH}${product.images[0]}`
                                  : img
                              }
                              alt="Product"
                            />
                            <div className="product-details1">
                              <div className="product-title1">
                                {product.productName} Lorem ipsum
                              </div>
                              <div className="product-price1">
                                <span className="selling-price1">
                                  ₹{product.sellingPrice}
                                </span>
                                <span>
                                  <span className="original-price1">
                                    ₹{product.MRP}
                                  </span>
                                  <span className="discount1">
                                    {(
                                      ((product.MRP - product.sellingPrice) /
                                        product.MRP) *
                                      100
                                    ).toFixed(2)}
                                    % off
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="button_container">
                            <button
                              className="button1"
                              onClick={() => handleAdd(product)}
                            >
                              Add to cart
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <NoData />
                  )}
                </>
                {/* ---------------------Product card end ----------------------- */}
              </div>

              <Footer />
            </>
          ) : (
            <Notfound />
          )}
        </>
      )}
    </>
  );
};

export default Search;
